import { cloneDeep, defaultsDeep } from 'lodash'

import { empty } from '@sigma-frontend-libs/commons'

import { serviceTemplate, services } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: services.requisites,

      async inputFilter(result) {
        if (!result.OwnerId) {
          result.OwnerId = result?.Owner?.id
        }

        return defaultsDeep(result, cloneDeep(empty.requisites.entity))
      },

      find: {
        defaultFilter: {
          OwnerId: undefined,
          isActive: true,
          $scope: [ 'Owner' ]
        }
      },

      width: 800,
      formClass: '',

      has: {
        clone: false
      }
    })
  ]
}
